const SIZE_CLASS = {
  xs: 'loading-xs',
  sm: 'loading-sm',
  md: 'loading-md',
  lg: 'loading-lg',
}

export default function Spinner({ size = 'md', className = '' }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`loading loading-spinner ${SIZE_CLASS[size] ?? SIZE_CLASS.md} ${className}`}
    />
  )
}

// Full-width centered spinner used while a page's data loads.
export function PageSpinner() {
  return (
    <div className="flex justify-center py-20">
      <Spinner size="lg" />
    </div>
  )
}
